import { z } from 'zod'

const withoutTrailingSlashes = (url: string) => url.replace(/\/+$/, '')

const envSchema = z.object({
  /** admin API base URL (`ADMIN_PORT` of apps/backend), no trailing slash */
  VITE_ADMIN_API_URL: z.url().transform(withoutTrailingSlashes),
  /**
   * cabinet's URL as the browser sees it, no trailing slash: staff open a
   * found test seed there. Optional (empty is none): without it the seed
   * finder offers no "Open in cabinet".
   */
  VITE_ADMIN_CABINET_URL: z.preprocess(
    (value) => (value === '' ? undefined : value),
    z.url().transform(withoutTrailingSlashes).optional(),
  ),
  /** admin-web apex hostname; tenants are `<slug>.<this>` (no scheme, no port) */
  VITE_ADMIN_BASE_DOMAIN: z
    .string()
    .trim()
    .toLowerCase()
    .regex(/^[a-z0-9.-]+$/, 'hostname only, e.g. sirius-admin.com'),
})

export type Env = z.infer<typeof envSchema>

/** Validates Vite's `import.meta.env`; throws listing every problem. */
export function parseEnv(raw: Record<string, unknown>): Env {
  const result = envSchema.safeParse(raw)
  if (!result.success) {
    throw new Error(`Invalid environment:\n${z.prettifyError(result.error)}`)
  }

  return result.data
}
